/** Every RecordFlow page lives under this path. */
export const ROOT_PATH = '/recordflow';
